export default {
  background_image: 'Immagine di sfondo',
};
